module.exports = {
  prefix: "wb-",
  content: [
    "./app/javascript/react/components/shared/BuilderUI/DefaultBlocks/**/*.{js,jsx,ts,tsx}",
    "./app/javascript/react/components/shared/BuilderUI/BlockSection/**/*.{js,jsx,ts,tsx}",
    "./app/javascript/react/components/shared/BuilderUI/DragAndDrop/**/*.{js,jsx,ts,tsx}",
  ],
  theme: {
    extend: {
      backgroundColor: {
        primary: "var(--theme-website-color-background-primary)",
        secondary: "var(--theme-website-color-background-secondary)",
        "button-primary":
          "var(--theme-website-primary-button-default-background-color)",
        "button-primary-hover":
          "var(--theme-website-primary-button-hover-background-color)",
        "button-secondary":
          "var(--theme-website-secondary-button-default-background-color)",
        "button-secondary-hover":
          "var(--theme-website-secondary-button-hover-background-color)",
      },

      textColor: {
        primary: "var(--theme-website-color-text-primary)",
        secondary: "var(--theme-website-color-text-secondary)",
        link: "var(--theme-website-color-text-link)",
        muted: "var(--theme-website-color-text-muted)",
        "button-primary-text":
          "var(--theme-website-primary-button-default-text-color)",
        "button-primary-text-hover":
          "var(--theme-website-primary-button-hover-text-color)",
        "button-secondary-text":
          "var(--theme-website-secondary-button-default-text-color)",
        "button-secondary-text-hover":
          "var(--theme-website-secondary-button-hover-text-color)",
        "h1-color": "var(--theme-website-h1-color-text)",
        "h2-color": "var(--theme-website-h2-color-text)",
        "h3-color": "var(--theme-website-h3-color-text)",
        "h4-color": "var(--theme-website-h4-color-text)",
        "h5-color": "var(--theme-website-h5-color-text)",
        "h6-color": "var(--theme-website-h6-color-text)",
        "p1-color": "var(--theme-website-p1-color-text)",
        "p2-color": "var(--theme-website-p2-color-text)",
        "p3-color": "var(--theme-website-p3-color-text)",
      },

      borderColor: {
        primary: "var(--theme-website-color-border-primary)",
        highlight: "var(--theme-website-color-border-highlight)",
        "button-primary":
          "var(--theme-website-primary-button-default-border-color)",
        "button-primary-hover":
          "var(--theme-website-primary-button-hover-border-color)",
        "button-secondary":
          "var(--theme-website-secondary-button-default-border-color)",
        "button-secondary-hover":
          "var(--theme-website-secondary-button-hover-border-color)",
      },

      fontFamily: {
        sans: ["InterVariable", "ui-sans-serif", "system-ui", "sans-serif"],
        h1: "var(--theme-website-h1-font-family)",
        h2: "var(--theme-website-h2-font-family)",
        h3: "var(--theme-website-h3-font-family)",
        h4: "var(--theme-website-h4-font-family)",
        h5: "var(--theme-website-h5-font-family)",
        h6: "var(--theme-website-h6-font-family)",
        p1: "var(--theme-website-p1-font-family)",
        p2: "var(--theme-website-p2-font-family)",
        p3: "var(--theme-website-p3-font-family)",
        "button-primary":
          "var(--theme-website-primary-button-default-font-family)",
        "button-primary-hover":
          "var(--theme-website-primary-button-hover-font-family)",
        "button-secondary":
          "var(--theme-website-secondary-button-default-font-family)",
        "button-secondary-hover":
          "var(--theme-website-secondary-button-hover-font-family)",
      },

      fontWeight: {
        h1: "var(--theme-website-h1-font-weight)",
        h2: "var(--theme-website-h2-font-weight)",
        h3: "var(--theme-website-h3-font-weight)",
        h4: "var(--theme-website-h4-font-weight)",
        h5: "var(--theme-website-h5-font-weight)",
        h6: "var(--theme-website-h6-font-weight)",
        p1: "var(--theme-website-p1-font-weight)",
        p2: "var(--theme-website-p2-font-weight)",
        p3: "var(--theme-website-p3-font-weight)",
        "button-primary":
          "var(--theme-website-primary-button-default-font-weight)",
        "button-primary-hover":
          "var(--theme-website-primary-button-hover-font-weight)",
        "button-secondary":
          "var(--theme-website-secondary-button-default-font-weight)",
        "button-secondary-hover":
          "var(--theme-website-secondary-button-hover-font-weight)",
      },

      fontSize: {
        h1: "var(--theme-website-h1-font-size)",
        h2: "var(--theme-website-h2-font-size)",
        h3: "var(--theme-website-h3-font-size)",
        h4: "var(--theme-website-h4-font-size)",
        h5: "var(--theme-website-h5-font-size)",
        h6: "var(--theme-website-h6-font-size)",
        p1: "var(--theme-website-p1-font-size)",
        p2: "var(--theme-website-p2-font-size)",
        p3: "var(--theme-website-p3-font-size)",
        link: "var(--theme-website-p1-font-size)",
        "button-primary":
          "var(--theme-website-primary-button-default-font-size)",
        "button-primary-hover":
          "var(--theme-website-primary-button-hover-font-size)",
        "button-secondary":
          "var(--theme-website-secondary-button-default-font-size)",
        "button-secondary-hover":
          "var(--theme-website-secondary-button-hover-font-size)",
      },

      lineHeight: {
        h1: "var(--theme-website-h1-line-height)",
        h2: "var(--theme-website-h2-line-height)",
        h3: "var(--theme-website-h3-line-height)",
        h4: "var(--theme-website-h4-line-height)",
        h5: "var(--theme-website-h5-line-height)",
        h6: "var(--theme-website-h6-line-height)",
        p1: "var(--theme-website-p1-line-height)",
        p2: "var(--theme-website-p2-line-height)",
        p3: "var(--theme-website-p3-line-height)",
        "button-primary":
          "var(--theme-website-primary-button-default-line-height)",
        "button-primary-hover":
          "var(--theme-website-primary-button-hover-line-height)",
        "button-secondary":
          "var(--theme-website-secondary-button-default-line-height)",
        "button-secondary-hover":
          "var(--theme-website-secondary-button-hover-line-height)",
      },

      borderWidth: {
        "button-primary":
          "var(--theme-website-primary-button-default-border-width)",
        "button-primary-hover":
          "var(--theme-website-primary-button-hover-border-width)",
        "button-secondary":
          "var(--theme-website-secondary-button-default-border-width)",
        "button-secondary-hover":
          "var(--theme-website-secondary-button-hover-border-width)",
      },

      padding: {
        "button-primary-top":
          "calc(var(--theme-website-primary-button-padding-top) * 1px)",
        "button-primary-bottom":
          "calc(var(--theme-website-primary-button-padding-bottom) * 1px)",
        "button-primary-left":
          "calc(var(--theme-website-primary-button-padding-left) * 1px)",
        "button-primary-right":
          "calc(var(--theme-website-primary-button-padding-right) * 1px)",
        "button-secondary-top":
          "calc(var(--theme-website-secondary-button-padding-top) * 1px)",
        "button-secondary-bottom":
          "calc(var(--theme-website-secondary-button-padding-bottom) * 1px)",
        "button-secondary-left":
          "calc(var(--theme-website-secondary-button-padding-left) * 1px)",
        "button-secondary-right":
          "calc(var(--theme-website-secondary-button-padding-right) * 1px)",
      },

      boxShadow: {
        "button-primary": "var(--theme-website-primary-button-default-shadow)",
        "button-primary-hover":
          "var(--theme-website-primary-button-hover-shadow)",
        "button-secondary":
          "var(--theme-website-secondary-button-default-shadow)",
        "button-secondary-hover":
          "var(--theme-website-secondary-button-hover-shadow)",
      },

      letterSpacing: {
        "button-primary":
          "var(--theme-website-primary-button-default-letter-spacing)",
        "button-primary-hover":
          "var(--theme-website-primary-button-hover-letter-spacing)",
        "button-secondary":
          "var(--theme-website-secondary-button-default-letter-spacing)",
        "button-secondary-hover":
          "var(--theme-website-secondary-button-hover-letter-spacing)",
        h1: "var(--theme-website-h1-letter-spacing)",
        h2: "var(--theme-website-h2-letter-spacing)",
        h3: "var(--theme-website-h3-letter-spacing)",
        h4: "var(--theme-website-h4-letter-spacing)",
        h5: "var(--theme-website-h5-letter-spacing)",
        h6: "var(--theme-website-h6-letter-spacing)",
        p1: "var(--theme-website-p1-letter-spacing)",
        p2: "var(--theme-website-p2-letter-spacing)",
        p3: "var(--theme-website-p3-letter-spacing)",
      },

      borderRadius: {
        "button-primary-default-left-top":
          "calc(var(--theme-website-primary-button-default-border-left-top-radius) * 1px)",
        "button-primary-default-left-bottom":
          "calc(var(--theme-website-primary-button-default-border-left-bottom-radius) * 1px)",
        "button-primary-default-right-top":
          "calc(var(--theme-website-primary-button-default-border-right-top-radius) * 1px)",
        "button-primary-default-right-bottom":
          "calc(var(--theme-website-primary-button-default-border-right-bottom-radius) * 1px)",
        "button-primary-hover-left-top":
          "calc(var(--theme-website-primary-button-hover-border-left-top-radius) * 1px)",
        "button-primary-hover-left-bottom":
          "calc(var(--theme-website-primary-button-hover-border-left-bottom-radius) * 1px)",
        "button-primary-hover-right-top":
          "calc(var(--theme-website-primary-button-hover-border-right-top-radius) * 1px)",
        "button-primary-hover-right-bottom":
          "calc(var(--theme-website-primary-button-hover-border-right-bottom-radius) * 1px)",
        "button-secondary-default-left-top":
          "calc(var(--theme-website-secondary-button-default-border-left-top-radius) * 1px)",
        "button-secondary-default-left-bottom":
          "calc(var(--theme-website-secondary-button-default-border-left-bottom-radius) * 1px)",
        "button-secondary-default-right-top":
          "calc(var(--theme-website-secondary-button-default-border-right-top-radius) * 1px)",
        "button-secondary-default-right-bottom":
          "calc(var(--theme-website-secondary-button-default-border-right-bottom-radius) * 1px)",
        "button-secondary-hover-left-top":
          "calc(var(--theme-website-secondary-button-hover-border-left-top-radius) * 1px)",
        "button-secondary-hover-left-bottom":
          "calc(var(--theme-website-secondary-button-hover-border-left-bottom-radius) * 1px)",
        "button-secondary-hover-right-top":
          "calc(var(--theme-website-secondary-button-hover-border-right-top-radius) * 1px)",
        "button-secondary-hover-right-bottom":
          "calc(var(--theme-website-secondary-button-hover-border-right-bottom-radius) * 1px)",
      },
    },
  },
  plugins: [],
  preflight: false,
};
